import { useTenant } from "hooks/useTenant";
import { createContext, ReactNode, useContext } from "react";

const TaskFormTenantContext = createContext<string | undefined>(undefined);

export function useTaskFormTenantId(): string | undefined {
  const overrideId = useContext(TaskFormTenantContext);
  const { tenantId: routeTenantId } = useTenant();
  return overrideId ?? routeTenantId;
}

export function TaskFormTenantProvider({
  tenantId,
  children,
}: {
  tenantId: string | null | undefined;
  children: ReactNode;
}) {
  return (
    <TaskFormTenantContext.Provider value={tenantId ?? undefined}>
      {children}
    </TaskFormTenantContext.Provider>
  );
}
